/*
 * there is problem in knockout router, that it sometimes doesn't 
 * clean views when child-routers are used. This fix is for that
 */
define('customPlugins/atnRouterViewFix',['knockout', 'lodash'], function(ko, _) {
    'use strict';
    ko.bindingHandlers.atnRouterViewFix = {
        init: function(element, valueAccessor) {
            // only accepts router as value
            var router = valueAccessor();
            router.on('router:navigation:composition-complete', function() {
                // check the children elements that matches 
                // [data-view*="views"][data-active-view="true"]
                var elements = _.filter(element.children, function(child) {
                    var dataView = child.getAttribute('data-view'),
                        dataActiveView = child.getAttribute('data-active-view');
                    return dataView.match('views') && dataActiveView === 'true';
                });
                // except the first element hide all matching elements
                _.each(elements, function(child, index) {
                    child.style.display = index ? 'none' : 'block';
                });
            });
        }
    };
});
